import { Chip } from "components/Chip/Chip";
import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import { useMemo } from "react";

export const FilterChipContainer = ({ currentFilter }: { currentFilter: string[] }) => {
    const filteredCurrentFilter = currentFilter.filter((item) => item);
    const shownItems = filteredCurrentFilter.slice(0, 3);
    const restItemsCount = filteredCurrentFilter.slice(3)?.length;

    return (
        <>
            {shownItems.map((item) => (
                <span className="selectedItem" key={item}>
                    <Chip
                        label={item.replaceAll("_", " ").toUpperCase()}
                        size="small"
                        variant="filled"
                        color="secondary"
                    />
                </span>
            ))}
            {restItemsCount ? (
                <Chip
                    label={`+${restItemsCount}`}
                    size="small"
                    variant="filled"
                    color="secondary"
                />
            ) : null}
        </>
    );
};

export const CheckboxTriggerButton = ({
    label,
    currentFilter,
    totalItemCount,
    notNull,
    customFilterText,
}: {
    label: string;
    currentFilter: string[];
    totalItemCount: number;
    notNull?: boolean;
    customFilterText?: "all" | "none" | React.ReactNode;
}) => {
    const filterText = useMemo(() => {
        if (customFilterText) {
            return customFilterText;
        }
        if (!currentFilter.length && !notNull) {
            return "none";
        }
        if (currentFilter.length === totalItemCount || (currentFilter.length === 0 && notNull)) {
            return "all";
        }
        return <FilterChipContainer currentFilter={currentFilter} />;
    }, [currentFilter, customFilterText, notNull, totalItemCount]);
    return (
        <button
            type="button"
            className={`button button--white record-filter-button record-filter-checkbox-button${
                filterText === "none" ? " button--warning" : ""
            }`}
        >
            <div>
                <span className="checkboxLabel">{`${label}: `}</span>
                <span>{filterText}</span>
            </div>
            <Icon icon={IconCollection.chevronDown} />
        </button>
    );
};
